import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './_router'
import store from './_store'
import './assets/tailwind.css'

// app.component('default-layout', theLayoutComponent)
// app.component('no-layout', theLayoutComponent)

createApp(App).use(store).use(router).mount('#app')
